import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { footerTranslations } from '../data/translations/footerTranslations';
import nvidiaInceptionBadge from '../assets/nvidia-inception-badge.svg';

export default function Footer() {
  const { language } = useLanguage();
  const t = footerTranslations[language].footer;

  return (
    <footer className="bg-background py-16 px-8 border-t border-border font-body text-on-background">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10">
        <div className="text-center md:text-left transition-all duration-300">
          <div className="text-xl font-bold text-primary mb-2 tracking-tight">intelimed.ai</div>
          <div className="text-muted text-[10px] font-medium tracking-wide uppercase">
            © 2024 intelimed.ai. {t.tagline}
          </div>
        </div>

        <nav className="flex flex-wrap justify-center items-center gap-8 md:gap-12" aria-label="Footer links">
          <button
            className="text-[10px] font-black text-muted hover:text-secondary uppercase tracking-[0.2em] transition-all"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
              else window.location.href = '/#contact';
            }}
          >
            {t.contact}
          </button>
          <a
            href="https://www.linkedin.com/company/intelimed-ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[10px] font-black text-muted hover:text-secondary uppercase tracking-[0.2em] transition-all"
          >
            <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            Intelimed
          </a>
        </nav>

        <img
          src={nvidiaInceptionBadge}
          alt="NVIDIA Inception Program"
          className="h-16 w-auto"
        />
      </div>
    </footer>
  );
}
// Cleaned up Footer with Accessibility repairs.